export default __webpack_public_path__ + "static/media/bg1.3618ec8d.png";